// extracted by mini-css-extract-plugin
module.exports = {"spinnerFixed":"Spinner_spinnerFixed__ro5Z7","fadeIn":"Spinner_fadeIn__0Sw3Q"};